export default __webpack_public_path__ + "static/media/6fav.16d5ee7e.jpg";